import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { Link as LinkScroll } from "react-scroll";
// Components
import Sidebar from "../Nav/Sidebar";
import Backdrop from "../Elements/Backdrop";
// Assets
import LogoImg from "../../../assets/images/s002.png";
import BurgerIcon from "../../../assets/svg/BurgerIcon";

export default function TopNavbar({sessionToken, sessionUser}) {
  const [y, setY] = useState(window.scrollY);
  const [sidebarOpen, toggleSidebar] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => setY(window.scrollY));
    return () => {
      window.removeEventListener("scroll", () => setY(window.scrollY));
    };
  }, [y]);

  return (
    <>
      <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} sessionToken={sessionToken} sessionUser={sessionUser} />
      {sidebarOpen && <Backdrop toggleSidebar={toggleSidebar} />}
      <Wrapper className="flexCenter animate whiteBg" style={y > 100 ? { height: "60px" } : { height: "80px" }}>
        <NavInner className="container flexSpaceCenter">
          <LinkScroll className="pointer flexNullCenter" to="home" smooth={true}>
            <img className="radius8" src={LogoImg} alt="GlupTickets Logo" style={{zIndex: 9, width:'170px'}} />
          </LinkScroll>
          <BurderWrapper className="pointer" onClick={() => toggleSidebar(!sidebarOpen)}>
            <BurgerIcon />
          </BurderWrapper>
          <UlWrapper className="flexNullCenter">
            <li className="semiBold font15 pointer">
              <LinkScroll activeClass="active" style={{ padding: "10px 15px" }} to="home" spy={true} smooth={true} offset={-80}>
                Inicio
              </LinkScroll>
            </li>
            {/* <li className="semiBold font15 pointer">
              <Link activeClass="active" style={{ padding: "10px 15px" }} to="services" spy={true} smooth={true} offset={-80}>
                Services
              </Link>
            </li>
            <li className="semiBold font15 pointer">
              <Link activeClass="active" style={{ padding: "10px 15px" }} to="projects" spy={true} smooth={true} offset={-80}>
                Projects
              </Link>
            </li>
            <li className="semiBold font15 pointer">
              <Link activeClass="active" style={{ padding: "10px 15px" }} to="blog" spy={true} smooth={true} offset={-80}>
                Blog
              </Link>
            </li> */}
            <li className="semiBold font15 pointer">
              <LinkScroll activeClass="active" style={{ padding: "10px 15px" }} to="features" spy={true} smooth={true} offset={-80}>
                Ventajas
              </LinkScroll>
            </li>
            <li className="semiBold font15 pointer">
              <LinkScroll activeClass="active" style={{ padding: "10px 15px" }} to="pricing" spy={true} smooth={true} offset={-80}>
                Precios
              </LinkScroll>
            </li>
            <li className="semiBold font15 pointer">
              <LinkScroll activeClass="active" style={{ padding: "10px 15px" }} to="contact" spy={true} smooth={true} offset={10}>
                Guia
              </LinkScroll>
            </li>
          </UlWrapper>
          <UlWrapperRight className="flexNullCenter">
            <li className="semiBold font15 pointer">
              {Boolean(!sessionToken) 
              ? <Link to={"/app"} style={{ padding: "10px 30px 10px 0" }}>
                Iniciar sesión
              </Link>
              : <Link to={"/app/logout"} style={{ padding: "10px 30px 10px 0" }}>
                Cerrar sesión
              </Link>
              }
            </li>
            <li className="semiBold font15 pointer flexCenter">
              <Link to={"/app/panel"} className="radius8 lightBg" style={{ padding: "10px 15px" }}>
                {Boolean(!sessionToken) ? "Empezar" : "Mi Panel" }
              </Link>
            </li>
          </UlWrapperRight>
        </NavInner>
      </Wrapper>
    </>
  );
}

const Wrapper = styled.nav`
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
`;
const NavInner = styled.div`
  position: relative;
  height: 100%;
`
const BurderWrapper = styled.button`
  outline: none;
  border: 0px;
  background-color: transparent;
  height: 100%;
  padding: 0 15px;
  display: none;
  @media (max-width: 760px) {
    display: block;
  }
`;
const UlWrapper = styled.ul`
  display: flex;
  @media (max-width: 760px) {
    display: none;
  }
`;
const UlWrapperRight = styled.ul`
  @media (max-width: 760px) {
    display: none;
  }
`;


